import script from "./Banners.vue?vue&type=script&setup=true&lang=js"
export * from "./Banners.vue?vue&type=script&setup=true&lang=js"

import "./Banners.vue?vue&type=style&index=0&id=5b985e2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b985e2b"]])

export default __exports__